var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatement = function SvgStatement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75A.75.75 0 0 1 7.75 8h5.5a.75.75 0 0 1 0 1.5h-5.5A.75.75 0 0 1 7 8.75Zm0 3.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25A2.25 2.25 0 0 1 6.25 4h8.5A2.25 2.25 0 0 1 17 6.25V14h3.5v3.25a3.25 3.25 0 0 1-3.25 3.25h-10A3.25 3.25 0 0 1 4 17.25v-11Zm13 9.25V19h.25A1.75 1.75 0 0 0 19 17.25V15.5h-2ZM15.5 19V6.25a.75.75 0 0 0-.75-.75h-8.5a.75.75 0 0 0-.75.75v11c0 .966.784 1.75 1.75 1.75h8.25Z",
    fill: "#666"
  })));
};
export default SvgStatement;